import React, { useState } from 'react';
import { newsItems } from '../data/news';

const PAGE_SIZE = 3;

const News: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(newsItems.length / PAGE_SIZE));
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const currentItems = newsItems.slice(startIndex, startIndex + PAGE_SIZE);

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <section id="news" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-flex items-center rounded-full bg-gradient-to-r from-brand-start/10 to-brand-end/10 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-brand-start mb-4">
            Latest updates
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-ink-900">
            News & Announcements
          </h2>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            Discover the latest partnerships, product updates, and milestones from 3B Consulting.
          </p>
        </div>

        <div className="space-y-6">
          {currentItems.map((item, index) => (
            <article
              key={item.id}
              className="glass-card p-8 border border-white/10 hover:border-brand-start/60 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between mb-4">
                <div>
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    {index === 0 && currentPage === 1 && (
                      <span className="inline-flex items-center rounded-full bg-gradient-to-r from-brand-start to-brand-end px-3 py-1 text-xs font-semibold text-white shadow-sm">
                        Featured
                      </span>
                    )}
                    <time
                      dateTime={item.date}
                      className="text-sm font-medium text-ink-500"
                    >
                      {new Date(item.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                      })}
                    </time>
                  </div>
                  <h3 className="text-2xl font-semibold text-ink-900">
                    {item.title}
                  </h3>
                </div>
              </div>
              <p className="text-ink-600 leading-relaxed">{item.summary}</p>
              {item.content && (
                <p className="text-ink-500 leading-relaxed mt-4">
                  {item.content}
                </p>
              )}
            </article>
          ))}

          {newsItems.length === 0 && (
            <div className="text-center text-ink-500">
              No news items available yet. Please check back soon.
            </div>
          )}
        </div>

        {newsItems.length > PAGE_SIZE && (
          <div className="flex items-center justify-center gap-4 mt-10">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-lg border text-sm font-medium transition-colors ${
                currentPage === 1
                  ? 'border-ink-200 text-ink-300 cursor-not-allowed'
                  : 'border-brand-start text-brand-start hover:bg-brand-start/10'
              }`}
            >
              Previous
            </button>

            <div className="flex items-center gap-2 text-sm text-ink-500">
              <span>
                Page <span className="font-semibold text-ink-800">{currentPage}</span> of{' '}
                <span className="font-semibold text-ink-800">{totalPages}</span>
              </span>
            </div>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded-lg border text-sm font-medium transition-colors ${
                currentPage === totalPages
                  ? 'border-ink-200 text-ink-300 cursor-not-allowed'
                  : 'border-brand-start text-brand-start hover:bg-brand-start/10'
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default News;

